import { useEffect } from 'react';
import { navigate } from "@reach/router"

const FireDepartmentsPage = () => {
  useEffect(() => {
    navigate('/solutions/industries/emergency-services/');
  }, []);
  return null;
};

export default FireDepartmentsPage;